import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { API_URL } from "../../config";

const SingleTransactionList = () => {
  const [TransactionSingleData, setTransactionSingleData] = useState(null);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();

  const fetchSingleTransaction = async () => {
    try {
      setLoading(true);
      const resp = await fetch(API_URL + "/api/wallet/getTransactionsDetails", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: JSON.stringify({ _id: id }),
      });
      const data = await resp.json();
      if (data.status === true) {
        setTransactionSingleData(data.data);
      } else {
        console.error("Invalid response data", data);
      }
    } catch (error) {
      console.error("Error fetching currency list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchSingleTransaction();
    }
  }, [id]);

  function formatDate(dateStr) {
    if (!dateStr) return "-";

    return new Date(dateStr).toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  }
  return (
    <div className="page-content">
      <Container fluid>
        <Card>
          <CardBody>
            <Row>
              <Col>
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18">Transaction Details</h4>
                </div>
              </Col>
            </Row>

            <Row>
              <Col sm="4" className="mb-2">
                <h5 className="font-size-16">Username :</h5>
              </Col>
              {TransactionSingleData?.map((o) => o?.username) || "-"}
            </Row>
            <Row>
              <Col sm="4" className="mb-2">
                <h5 className="font-size-16">Email :</h5>
              </Col>
              {TransactionSingleData?.map((o) => o?.email) || "-"}
            </Row>
            <Row>
              <Col sm="4" className="mb-2">
                <h5 className="font-size-16">Phone :</h5>
              </Col>
              {TransactionSingleData?.map((o) => o?.phoneno) || "-"}
            </Row>
            <Row>
              <Col sm="4" className="mb-2">
                <h5 className="font-size-16">Amount :</h5>
              </Col>
              {TransactionSingleData?.map((o) => o?.amount) || "-"}
            </Row>
            <Row>
              <Col sm="4" className="mb-2">
                <h5 className="font-size-16">Currency :</h5>
              </Col>
              {TransactionSingleData?.map(
                (o) => o?.currencyDet?.currencySymbol
              )}{" "}
              - {TransactionSingleData?.map((o) => o?.currencyDet?.basecoin)}
            </Row>
            <Row>
              <Col sm="4" className="mb-2">
                <h5 className="font-size-16">Type :</h5>
              </Col>
              {TransactionSingleData?.map((o) => o?.type) || "-"}
            </Row>
            <Row>
              <Col sm="4" className="mb-2">
                <h5 className="font-size-16">Transaction Id :</h5>
              </Col>
              {TransactionSingleData?.map((o) => o?.txnId) || "-"}
            </Row>
            <Row>
              <Col sm="4" className="mb-2">
                <h5 className="font-size-16">Status :</h5>
              </Col>
              <Col>
                {TransactionSingleData?.length > 0
                  ? TransactionSingleData.map((o, i) => (
                      <span key={i}>
                        {o?.status === 0
                          ? "Pending"
                          : o?.status === 1
                          ? "Approved"
                          : o?.status === 2
                          ? "Rejected"
                          : "Processing"}
                      </span>
                    ))
                  : "-"}
              </Col>
            </Row>
            <Row>
              <Col sm="4" className="mb-2">
                <h5 className="font-size-16">Transaction Date :</h5>
              </Col>
              {formatDate(TransactionSingleData?.map((o) => o?.createdDate)) ||
                "-"}
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default SingleTransactionList;
